import FundInvestmentsWidget from './FundInvestmentsWidget'

export default FundInvestmentsWidget
